import React, { useState } from "react"
import Select from "react-select"
import {
	Button,
	FormControl,
	Modal,
	ModalOverlay,
	ModalHeader,
	ModalFooter,
	ModalContent,
	ModalCloseButton,
	ModalBody,
} from "@chakra-ui/react"
import {
	collection,
	query,
	where,
	getDocs,
	updateDoc,
} from "firebase/firestore"
import { db } from "../firebase"
import { BlackDomeStatuses } from "../Options/BlackDomeStatuses"

export const BlackDomeStatusModal = ({
	jobRequest,
	isOpen,
	onClose,
	setStatusModal,
}) => {
	const [isUpdating, setIsUpdating] = useState(false)
	const [value, setValue] = useState(null)

	const workOrderOptions = BlackDomeStatuses.map((status) => ({
		label: status.label,
		value: status.value,
	}))

	const onSubmit = async () => {
		if (isUpdating) return

		setIsUpdating(true)
		const q = query(
			collection(db, "jobRequests"),
			where("id", "==", jobRequest.id)
		)
		const docSnap = await getDocs(q)

		await updateDoc(docSnap.docs[0].ref, {
			blackDomeStatus: value,
		})

		setIsUpdating(false)
		onClose()
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} size="3xl">
			<ModalOverlay />
			<ModalContent mx={{ base: "10px", md: "0px" }}>
				<ModalHeader>Update Work Order Status</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<FormControl>
						<Select
							border="1px solid #E2E2EA"
							placeholder="Select status"
							options={workOrderOptions}
							name="clientIds"
							value={workOrderOptions.filter(
								(option) => value === option.value
							)}
							onChange={(e) => {
								setValue(e.value)
							}}
						/>
					</FormControl>
				</ModalBody>
				<ModalFooter>
					<Button
						mr={3}
						onClick={onSubmit}
						w="100%"
						bg="borderColor"
						color="white"
						_hover={{ bgColor: "borderColor" }}
					>
						Update
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}
